const FIFTEEN_MINUTES = 15 * 60 * 1000; // (tempo que eu quero que sessao fique valida) 15 minutos em milissegundos 

export function isSessionValid() {
  const storedUser = JSON.parse(localStorage.getItem('user'));
  const loginTime = localStorage.getItem('loginTime');
  return storedUser && loginTime && Date.now() - loginTime < FIFTEEN_MINUTES;
}